export default {
  programYear: '2026',
  options: {},
};
